module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Hidden in the Stars")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Designed by Sarah Soward")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("VITAL STATISTICS")])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_vm._v("Quilt size:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("54in x 62in")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Block size:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("10in x 6in")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Number of blocks:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("35")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Setting:")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("7 x 5 blocks with 2in inner, middle and outer borders")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("“I love jelly rolls! I find that quilting with them does so much to ease the stresses of the working day. So far, I have created four jelly roll quilts and one jelly roll and layer cake quilt. When I was told about the competition, I decided that I should produce a design that is fairly simple and not too complicated to make for people who have never used a jelly roll before. I came up with the name ‘Hidden in the Stars’ for my quilt as the angles that I have cut the jelly roll into make a variation on a star. I hope that you get the same amount of relaxing enjoyment out of creating your own jelly roll quilts as I have done.” Sarah Soward")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pam and Nicky’s variation quilt on page 17 uses whites, blacks and reds in a dramatic colour combination.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("REQUIREMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("•One jelly roll "), _c('strong', [_vm._v("OR")]), _vm._v(" forty 21/2in strips cut across the width of the fabric")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("•11/2yd (1.5m) of accent fabric for block corners and inner border")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("•20in (50cm) of fabric for binding")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Sorting the Jelly Roll Strips")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Choose twenty-seven strips for the blocks. The remaining thirteen strips will be used for your middle and outer borders.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Read all of the instructions through before starting your quilt. Use a scant 1/4in seam allowance throughout.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Cutting Instructions")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('em', [_vm._v("Jelly roll strips:")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Take the thirteen strips allocated for the borders and cut them in half (21/2in x 22in).")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('em', [_vm._v("Accent fabric:")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Cut seven strips 41/4in wide across the width of the fabric. These are for your block corners.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Cut seven strips 21/2in wide across the width of the fabric. "), _c('br'), _vm._v("This is for your inner border.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('em', [_vm._v("Binding:")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Cut six 21/2in wide strips across the width of the fabric.")])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Making the Strip Blocks")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("1")]), _vm._v(" From your twenty-seven strips, choose three and sew together along the length to form a set as shown in the diagram below. Repeat with the remaining strips. You need a total of nine sets. To help avoid bowing of the strips, set and press seams before sewing the next strip. Press towards the darker fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("2")]), _vm._v("Trim the selvedge and cut four 101/2in segments from each set. Straighten the edges between each cut, if necessary. You need thirty-five 101/2in sections in total so you will have one spare.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("3")]), _vm._v("Position the 60 degree marking on your ruler along one edge as shown below and cut one 60 degree angle from each 101/2in section.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("4")]), _vm._v("Once you have cut the 60 degree angle from each section, attach the sections to the 41/4in strips from your accent fabric. This is done by what is known as the ‘washing line’ method. You will be able to get five of your sections onto each strip. With your 41/4in strip underneath sew the sections right sides together.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("5")]), _vm._v("Set the seam and then press seams to your background fabric. Now cut in between each section to separate them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("6")]), _vm._v("Trim the edges of the background fabric in line with your strip set. Then cut the top off 1/4in from the point of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/15-4.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Assembling the Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Lay out the blocks with seven blocks across and five down, rotating alternate blocks 180 degrees as shown in the diagram below. Sew the blocks together to complete a row.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Now sew the rows together, pinning at every seam intersection to ensure a perfect match.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/16-1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Adding the Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('em', [_vm._v("Inner Border:")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Sew the inner border strips into one continuous length.Measure the vertical length of the quilt top, taking the measurement from the middle of your quilt and cut two lengths to this measurement from your continuous length of inner border fabric. Pin to the sides of your quilt and sew together. Then measure across the horizontal of your quilt top and cut two lengths to this measurement and sew to the top and bottom of your quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_c('em', [_vm._v("Middle and outer borders:")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Take the twenty-six jelly roll half strips and sew together to form one continuous length. Add the middle and outer borders, following the instructions for the inner border, above.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("When sewing the jelly roll half strips for her middle and outer borders, Sarah sewed them on the diagonal to create added interest. If you wish to do the same, refer to Joining Borders and Binding Strips on page 118.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Finishing the Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Your quilt top is now complete. Prepare the top for quilting and then quilt as desired. Bind the quilt to finish (see page 120).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/18-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Hidden in the Stars Variation")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("We chose to make our variation in a black and white jelly roll with a red accent fabric. This is a perfect example of how to create a stunning quilt in the simplest way possible. The large blocks are quick and easy to piece and the quilt goes together in no time at all. It would be a good quilt to inspire a budding quilter. We need to encourage the next generation to start quilting and this quilt might be the perfect opportunity. In our variation, we added cornerstones from our excess accent fabric to add an extra dimension to the borders. Quilt made by Pam and Nicky Lintott and longarm quilted by The Quilt Room.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4042e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446350935_epub_c01_r1.vue
// module id = 72
// module chunks = 0